import { AuthenticatedUser, User } from './types';

export const userAsUnauthenticated = (user: AuthenticatedUser): User => {
  const { userId, username, fullName } = user;

  return { userId, username, fullName };
};
